import { Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

import { LIVE_LOGS_I18N } from './liveLogs';

export const LiveLogsEmpty = () => {
  const translate = useTranslate();

  return (
    <Typography variant="body2" color="text.secondary" sx={{ py: 4, px: 2 }}>
      {translate(`${LIVE_LOGS_I18N}.empty`)}
    </Typography>
  );
};
